export default "__VITE_ASSET__CTy$GaKE__"